// config/api.js
import axios from "axios";

// export const API_URL = "http://localhost:8080"
export const API_URL = "https://quickbite-backend-58ik.onrender.com"

export const api=axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  }
})
